import type { FC } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

export type CurativeIncidentSummaryTextProps = {
  fallbackTitle: string | null;
  maxRows?: number;
};

export const CurativeIncidentSummaryText: FC<
  CurativeIncidentSummaryTextProps
> = ({ fallbackTitle, maxRows = 3 }) => {
  const { t } = useTranslation('maintenance');
  const summaryText = fallbackTitle?.trim() ?? '';

  if (!summaryText) {
    return (
      <Typography.Text
        type="secondary"
        style={{ fontSize: 11, display: 'block', marginTop: 4 }}
      >
        {t('workOrders.kanban.incidentSummaryEmpty')}
      </Typography.Text>
    );
  }

  return (
    <Typography.Paragraph
      type="secondary"
      ellipsis={
        maxRows > 0 ? { rows: maxRows, expandable: true, symbol: '…' } : false
      }
      style={{ margin: '4px 0 0', fontSize: 11, lineHeight: 1.45 }}
    >
      {summaryText}
    </Typography.Paragraph>
  );
};
